import { render } from "./FilterCategoryBlock.vue?vue&type=template&id=71443502&scoped=true"
import script from "./FilterCategoryBlock.vue?vue&type=script&lang=js"
export * from "./FilterCategoryBlock.vue?vue&type=script&lang=js"

import "./FilterCategoryBlock.vue?vue&type=style&index=0&id=71443502&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71443502"]])

export default __exports__